import mrpStyles from './../mrp.json'

export default {
  weight: 'normal',
  color: mrpStyles.colors.PrimaryBlack,
  inverseColor: mrpStyles.colors.PrimaryWhite
}
